import { init } from '@elastic/apm-rum';

let environment = window.process.env.APP_ENV || 'local';
environment = environment === '##APP_ENV##' ? 'local' : environment;

export const logging = init({
  serviceName: 'app-ehyp-sales',
  serviceVersion: process.env.APP_VERSION,
  serverUrl: '/api/apm',
  logLevel: 'info',
  active: environment !== 'ci' && environment !== 'local',
  environment,
});
